var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * NumberTwoFilled component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconNumberTwoFilled extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 23C14.9174 23 17.7153 21.8411 19.7782 19.7782C21.8411 17.7153 23 14.9174 23 12C23 9.08262 21.8411 6.28473 19.7782 4.22183C17.7153 2.15893 14.9174 1 12 1C9.08262 1 6.28473 2.15893 4.22183 4.22183C2.15893 6.28473 1 9.08262 1 12C1 14.9174 2.15893 17.7153 4.22183 19.7782C6.28473 21.8411 9.08262 23 12 23ZM11.2143 6.30357C9.75914 6.30357 8.52243 7.23386 8.06514 8.53029C7.97845 8.77597 7.99292 9.04603 8.10534 9.28105C8.21777 9.51608 8.41896 9.69681 8.66464 9.7835C8.91033 9.87019 9.18039 9.85573 9.41541 9.7433C9.65043 9.63087 9.83117 9.42969 9.91786 9.184C10.0129 8.91613 10.1886 8.68427 10.4207 8.52023C10.6528 8.35619 10.93 8.26803 11.2143 8.26786H12.847C13.1488 8.26781 13.4413 8.37165 13.6756 8.56192C13.9098 8.7522 14.0713 9.0173 14.1331 9.31267C14.1949 9.60804 14.1531 9.91568 14.0147 10.1839C13.8764 10.452 13.6499 10.6644 13.3734 10.7853L9.87543 12.3159C9.28066 12.5762 8.77467 13.0042 8.41938 13.5476C8.06409 14.091 7.87491 14.7262 7.875 15.3754V16.7143C7.875 17.2564 8.315 17.6964 8.85714 17.6964H15.1429C15.4033 17.6964 15.6531 17.593 15.8373 17.4088C16.0215 17.2246 16.125 16.9748 16.125 16.7143C16.125 16.4538 16.0215 16.204 15.8373 16.0198C15.6531 15.8356 15.4033 15.7321 15.1429 15.7321H9.83929V15.3754C9.83929 14.8286 10.163 14.3336 10.6627 14.1151L14.1607 12.5846C14.8503 12.2828 15.415 11.7528 15.76 11.0838C16.105 10.4147 16.2091 9.64729 16.055 8.91048C15.9009 8.17367 15.4979 7.51234 14.9137 7.03762C14.3295 6.56289 13.5998 6.3037 12.847 6.30357H11.2143Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconNumberTwoFilled.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconNumberTwoFilled.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconNumberTwoFilled.prototype, "size", void 0);
if (customElements.get('cat-icon-number-two-filled') === undefined) {
    customElements.define('cat-icon-number-two-filled', BlocksIconNumberTwoFilled);
}
